import type { Content, StyleDictionary, TableCell } from 'pdfmake/interfaces';
import { DEFAULT_COMPONENT_SPACING, pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';

export const DEFAULT_COLUMN_AMOUNT = 2;

export class DataGrid implements BaseReportComponent {
	constructor(
		private entries: [string, string][],
		private columnAmount = DEFAULT_COLUMN_AMOUNT
	) {}

	exportContent(): Content {
		const rows: TableCell[][] = [];

		for (let i = 0; i < this.entries.length; i += this.columnAmount) {
			// We fill this array with empty strings to pad out the table render
			const row: TableCell[] = Array(this.columnAmount).fill('');
			for (let j = 0; j < this.columnAmount; j++) {
				const index = i + j;
				if (index < this.entries.length) {
					const [title, value] = this.entries[index];

					row[j] = {
						columnGap: pdfTheme.spacing.default,
						columns: [
							{
								text: `${title}:`,
								style: ['cellTitle'],
								width: 'auto',
							},
							{
								text: value,
								style: ['cellValue'],
							},
						],
					};
				}
			}

			rows.push(row);
		}

		return {
			layout: 'noBorders',
			table: {
				// If there are no rows, then we need an empty 2d array to successfully render the table
				body: rows.length ? rows : [[]],
			},
			style: ['dataGrid'],
		};
	}

	exportStyles(): StyleDictionary {
		return {
			dataGrid: {
				fontSize: 12,
				marginBottom: DEFAULT_COMPONENT_SPACING,
				marginLeft: DEFAULT_COMPONENT_SPACING,
				marginRight: DEFAULT_COMPONENT_SPACING,
			},
			cellTitle: {
				bold: true,
				fontSize: 12,
			},
			cellValue: {
				fontSize: 10,
				marginTop: 2,
			},
		};
	}
}
